module.exports = __webpack_public_path__ + "static/img/icon_del.3c02b906.png";